import { defineComponent as v, ref as J, onMounted as _, onUnmounted as j, watch as w, openBlock as B, createElementBlock as x, normalizeClass as z } from "vue";
import { indentWithTab as H } from "./ghl-ui.es262.js";
import { css as N } from "./ghl-ui.es263.js";
import { html as O, htmlLanguage as P, htmlCompletionSource as U } from "./ghl-ui.es264.js";
import { esLint as S, javascript as V, javascriptLanguage as k, scopeCompletionSource as M } from "./ghl-ui.es265.js";
import { json as R, jsonLanguage as q, jsonParseLinter as D } from "./ghl-ui.es266.js";
import { linter as f, lintGutter as l } from "./ghl-ui.es267.js";
import { EditorState as F } from "./ghl-ui.es268.js";
import { EditorView as y, keymap as G } from "./ghl-ui.es269.js";
import { basicSetup as u } from "./ghl-ui.es270.js";
import C from "./ghl-ui.es271.js";
import W from "./ghl-ui.es272.js";
import K from "./ghl-ui.es273.js";
import Q from "./ghl-ui.es274.js";
import d from "./ghl-ui.es275.js";
import { Languages as r, EventType as n } from "./ghl-ui.es276.js";
import "./ghl-ui.es277.js";
const X = ["id"], Y = v({
  name: "UICodeEditor",
  inheritAttrs: !1
}), Z = v({
  ...Y,
  props: {
    value: String,
    language: String,
    id: {
      type: String,
      required: !0,
      default: "ghl-editor"
    },
    resize: {
      type: Boolean,
      default: !0
    },
    prettify: {
      type: Boolean,
      default: !0
    }
  },
  emits: ["update:value"],
  setup(p, { expose: T, emit: E }) {
    const o = p;
    let a = null;
    const c = E, g = J(null), L = (e) => {
      if (!a)
        return !1;
      a.dispatch({
        changes: {
          from: 0,
          to: a.state.doc.length,
          insert: i(e)
        }
      }), c("update:value", i(e));
    }, i = (e) => {
      if (!o.prettify)
        return e;
      try {
        if (o.language === r.CSS)
          return d.format(e, {
            parser: "css",
            plugins: [Q]
          });
        if (o.language === r.JAVASCRIPT)
          return d.format(e, {
            parser: "babel",
            plugins: [W]
          });
        if (o.language === r.HTML)
          return d.format(e, {
            parser: "html",
            plugins: [K]
          });
        if (o.language === r.JSON)
          return JSON.stringify(JSON.parse(e), null, 2);
      } catch {
        return e;
      }
    }, m = (e, t) => {
      const I = [
        n.Input,
        n.Blur,
        n.Focus,
        n.Paste
      ];
      if (!e || !I.includes(t))
        return !1;
      setTimeout(() => {
        let s = e.state.doc.toString();
        t !== n.Input && (s = i(s), e.dispatch({
          changes: {
            from: 0,
            to: e.state.doc.length,
            insert: s
          }
        })), c("update:value", s);
      }, 0);
    }, b = {
      [r.JAVASCRIPT]: [
        f(S(new C())),
        l(),
        u,
        V(),
        k.data.of({
          autocomplete: M(globalThis)
        })
      ],
      [r.CSS]: [
        f(S(new C())),
        l(),
        u,
        N()
      ],
      [r.HTML]: [
        l(),
        u,
        O(),
        P.data.of({
          autocomplete: U
        })
      ],
      [r.JSON]: [
        l(),
        u,
        f(D()),
        R(),
        q
      ]
    }, A = [
      y.domEventHandlers({
        input: (e, t) => m(t, e.type),
        paste: (e, t) => m(t, e.type),
        blur: (e, t) => m(t, e.type)
      })
    ], h = (e = r.JAVASCRIPT) => {
      a && a.destroy(), a = new y({
        state: F.create({
          doc: i(o.value),
          extensions: [
            ...b[e],
            ...A,
            G.of([H])
          ]
        }),
        parent: g.value
      });
    };
    return _(() => h(o.language)), j(() => a && a.destroy()), T({
      setContent: L
    }), w(
      () => o.language,
      (e) => {
        h(e);
      }
    ), (e, t) => (B(), x("div", {
      ref_key: "editorContainer",
      ref: g,
      class: z(["ghl-code-mirror", p.resize ? "allow-resize" : null].join(" ")),
      id: p.id
    }, null, 10, X));
  }
}), he = Z;
export {
  he as default
};
